<script setup>
import { computed } from 'vue';
import { ref } from 'vue';

const props = defineProps({
    icon: {
        type: String,
        required: true
    },
    type: {
        type: String,
        required: false,
        default: 'default'
    }
});

const colors = ref([
    {
        type: 'warning',
        icon: 'text-amber-500',
        bg: 'bg-amber-50',
        border: 'border-amber-200'
    },
    {
        type: 'success',
        icon: 'text-green-500',
        bg: 'bg-green-50',
        border: 'border-green-200'
    },
    {
        type: 'info',
        icon: 'text-blue-500',
        bg: 'bg-blue-50',
        border: 'border-blue-200'
    },
    {
        type: 'danger',
        icon: 'text-red-500',
        bg: 'bg-red-50',
        border: 'border-red-200'
    },
    {
        type: 'default',
        icon: 'text-gray-500',
        bg: 'bg-gray-50',
        border: 'border-gray-200'
    }
]);

const setColors = computed(() => {
    const color = colors.value.find(color => color.type === props.type);
    return color;
});

</script>

<template>
    <div class="p-4 border rounded-lg" :class="setColors.border + ' ' + setColors.bg">
        <h3 class="flex items-center text-lg font-semibold text-gray-900">
            <i
                class="flex items-center justify-center flex-shrink-0 w-5 h-5 mr-4 text-lg fa-regular"
                :class="'fa-'+icon + ' ' + setColors.icon"
            ></i>
            <slot name="header"></slot>
        </h3>
        <div class="mt-3 space-y-3 -mx-4 md:mx-0">
            <div class="p-3 bg-white border-y md:border border-gray-100 md:rounded">
                <slot name="body"></slot>
            </div>

            <div v-if="$slots.fineprint" class="p-3 bg-white border border-gray-100 rounded">
                <slot name="fineprint"></slot>
            </div>
        </div>
    </div>
</template>

